import React from "react";
import { Container } from "@mui/material";
import HeaderHelpPage from "../../../components/HeaderHelpPage";
import ExchangeRates from "./exchange-rates";
import { StorageUtils } from "../../../utils";
import { APP_USER_SESSION } from "../../../constant/AppConstants";

const ExchangeRatesPage = () => {
  const userRole = StorageUtils.getParsedValue(APP_USER_SESSION)?.role || {};
  const exchangeRateRole = userRole.exchange_rate || [];
  return (
    <Container>
      <HeaderHelpPage 
        title="Exchange Rates" 
        description="This page manage Exchange Rates on our system."
      />
      <ExchangeRates userRole={exchangeRateRole} />
    </Container>
  );
};

export default ExchangeRatesPage;
